// extracted by mini-css-extract-plugin
export default {"footerContent":"footer_footerContent__duq4o","social":"footer_social__eGScn"};